module.exports = __webpack_public_path__ + "static/modal-bg.78ecbe35.png";